/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class BillingDetails implements Serializable<BillingDetails> {
    id: string;
    discount: number;
    planId: string;
    price: any;
    billingCycle: number;
    billingCycleName: string;
    unitPrice: number;
    braintreePlanId: string;
    name: string;

    constructor() {
    }

    deserialize(input: any) {
        input.id && (this.id = input.id);
        input.discount && (this.discount = input.discount);
        input.planId && (this.planId = input.planId);
        input.braintreePlanId && (this.braintreePlanId = input.braintreePlanId);
        input.price && (this.price = input.price);
        input.billingCycleInMonths && (this.billingCycle = input.billingCycleInMonths);

        switch (this.billingCycle) {
            case 1:
                this.billingCycleName = ' per user/month';
                this.name = 'Monthly';
                break;
            case 3:
                this.billingCycleName = ' per user/quarter';
                this.name = 'Quarterly';
                break;
            case 6:
                this.billingCycleName = ' per user/half year';
                this.name = 'Half Yearly';
                break;
            case 12:
                this.billingCycleName = ' per user/year';
                this.name = 'Yearly';
                break;
        }

        this.unitPrice = (this.price / this.billingCycle);
        return this;
    }


}


export class UserSubscription implements Serializable<UserSubscription> {
    userId: string;
    billingCycleId: number;
    isActive: boolean;
    nextPaymentDueDate: string;
    subscriptionDate: number;
    subscriptionEndDate: number;
    planName: string;

    constructor() {
    }

    deserialize(input: any) {
        input.userId && (this.userId = input.userId);
        input.billingCycleId && (this.billingCycleId = input.billingCycleId);
        input.isActive && (this.isActive = input.isActive);
        input.nextPaymentDueDate && (this.nextPaymentDueDate = input.nextPaymentDueDate);
        input.subscriptionDate && (this.subscriptionDate = input.subscriptionDate);
        input.subscriptionEndDate && (this.subscriptionEndDate = input.subscriptionEndDate);
        input.planName && (this.planName = input.planName);
        return this;
    }


}

export class CurrentUsage implements Serializable<CurrentUsage> {
    careTeam: string;
    discussions: number;
    documents: number;
    galleryPhotos: number;
    userId: number;

    constructor() {
    }

    deserialize(input: any) {
        (this.careTeam = input.careTeamCount);
        (this.discussions = input.discussionCount);
        (this.documents = input.documentCount);
        (this.galleryPhotos = input.galleryPhotosCount);
        (this.userId = input.userId);

        return this;
    }


}
